import { Map, Record } from "immutable";
import { DabellaCustomFormRecord, customFormFromJSON } from "common/records/DabellaCustomForm";
import { RootActions, RootState } from "common/reducers";
import {
  DabellaCustomFormActions,
  RECEIVE_CUSTOM_FORM,
  RECEIVE_CUSTOM_FORMS,
  SET_APPLICANT_COUNT,
  UPDATE_DABELLA_FORM,
  RESET_DABELLA_FORM,
  CLEANUP_DABELLA_FORM,
} from "common/reducers/dabellaCustomForm.actions";
import { receive, reset } from "common/reducers/Utils";
import { PhoneNumberFormat } from "common/helpers/Format";

export const DabellaCustomFormApplicantImageDataRecord = Record({
  license_image_front: null as string | null,
  license_image_back: null as string | null,
});

export const DabellaCustomFormImagePiiDataRecord = Record({
  applicant: DabellaCustomFormApplicantImageDataRecord(),
  co_applicant: DabellaCustomFormApplicantImageDataRecord(),
});

export const DabellaCustomFormStateRecord = Record({
  byId: Map<string, DabellaCustomFormRecord>(),
  lastSavedById: Map<string, DabellaCustomFormRecord>(),
  applicantsCountByJobId: Map<number, number>(),
  customFormImagePiiData: DabellaCustomFormImagePiiDataRecord(),
});

export const initialState = DabellaCustomFormStateRecord();

export const model = "dabellaCustomForms";

export type DabellaCustomFormState = typeof initialState;

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    return state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_CUSTOM_FORMS: {
      const { customForms } = action.payload;
      customForms.forEach((customForm) => {
        state = reducer(state, DabellaCustomFormActions.receiveCustomForm(customForm));
      });
      return state;
    }

    case RECEIVE_CUSTOM_FORM: {
      const { customForm } = action.payload;
      const customFormRecord = customFormFromJSON({ ...customForm });

      return receive(state, model, customFormRecord) as RootState;
    }

    case UPDATE_DABELLA_FORM: {
      const { rootPath, name } = action.payload.event;
      let { value } = action.payload.event;

      // Handle phone number formatting
      if (name.includes("phone")) {
        value = PhoneNumberFormat(value);
      }

      state = state.setIn(rootPath.concat(name.split(".")), value);

      return state;
    }

    case RESET_DABELLA_FORM: {
      const formId = -1;
      return reset(state, model, formId).setIn(
        [model, "customFormImagePiiData"],
        DabellaCustomFormImagePiiDataRecord(),
      );
    }

    case CLEANUP_DABELLA_FORM: {
      return state
        .deleteIn([model, "byId", -1])
        .deleteIn([model, "lastSavedById", -1])
        .setIn([model, "customFormImagePiiData"], DabellaCustomFormImagePiiDataRecord());
    }

    case SET_APPLICANT_COUNT: {
      const { jobId, customForms } = action.payload;
      const single = ["INDIVIDUAL CREDIT", "INDIVIDUAL (REMOTE)"];
      const double = ["JOINT CREDIT"];

      let count = 0;

      customForms.forEach((customForm) => {
        if (single.includes(customForm.form_data?.application_status)) {
          count++;
        } else if (double.includes(customForm.form_data?.application_status)) {
          count += 2;
        }
      });

      return state.setIn([model, "applicantsCountByJobId", jobId], count);
    }

    default:
      return state;
  }
};
